"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomMAOptionType = void 0;
var RandomMAOptionType;
(function (RandomMAOptionType) {
    RandomMAOptionType["NONE"] = "No randomization";
    RandomMAOptionType["LIMITED"] = "Limited synergy";
    RandomMAOptionType["UNLIMITED"] = "Full random";
})(RandomMAOptionType || (exports.RandomMAOptionType = RandomMAOptionType = {}));
